
import { System, SystemDetails, SystemPlanStyle } from "@ews/react-data";
import { useL10n } from "@ews/react-localization-context";
import { useRef } from "react";
import { AlignmentsTranslationKey, fontFamilies, fontWeights, labelPosition } from "../../../Plan/components/Element/types";
import { useModifySystemDetails, useSystemDetails } from "../../../ReactData/system";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsNumberInput from "../../../Settings/SettingsComponents/SettingsNumberInput/SettingsNumberInput";
import SettingsSelect from "../../../Settings/SettingsComponents/SettingsSelect/SettingsSelect";
import SettingsSelectOption from "../../../Settings/SettingsComponents/SettingsSelectOption/SettingsSelectOption";
import { PlanViewProps } from "./types";
import { Locale } from "../../../../setup/locale";
import { PlanLabelTemplates } from "../../../Plan/components/Element/Element";
import { floatingPromiseHandler } from "../../../../utils";
import { IonButton, IonItem } from "@ionic/react";
import { useInvokeUpdatePlanStyle } from "../../../ReactData/rpc";


const PlanView: React.FC<PlanViewProps> = ({ systemId }) =>
{
    const { translate: t } = useL10n();
    const details = useSystemDetails(systemId);
    const modifySystemDetails = useModifySystemDetails();

    const { defaultPlanStyle } = details;

    function saveSystemDetailsDefaultStyle(id: System["id"], data: SystemPlanStyle)
    {

        if (!id || Object.keys(data).length === 0) return;

        const planStyle = { defaultPlanStyle: { ...defaultPlanStyle, ...data } } as SystemDetails;

        modifySystemDetails(id, planStyle).catch(floatingPromiseHandler(import.meta.url));
    }

    const fontSizeRef = useRef<HTMLIonInputElement>(null);
    const IconScaleRef = useRef<HTMLIonInputElement>(null);

    const bgValue = defaultPlanStyle?.labelBackground;


    const callUpdatePlanStyle = useInvokeUpdatePlanStyle();
    function updatePlanStyle()
    {
        if (!systemId) {
            console.error("trying to call callUpdatePlanStyle but systemId is falsy!");
            return;
        }
        callUpdatePlanStyle({ systemId });
    }


    return <>
        <SettingsCol >
            <SettingsSelect
                value={defaultPlanStyle?.label}
                text={"[REACT_LABEL_TEMPLATE]"}
                onSelect={(label) =>
                {
                    saveSystemDetailsDefaultStyle(systemId, { label });
                }}
            >
                <PlanLabelTemplates />
            </SettingsSelect>

            <SettingsSelect
                text="MOD_FINDER_FIELDSET_ADVANCED_LABEL_POS_LABEL"
                value={defaultPlanStyle?.labelPosition}
                onSelect={(labelPosition) =>
                {
                    saveSystemDetailsDefaultStyle(systemId, { labelPosition });
                }}
            >
                {labelPosition.map((position, i) => <SettingsSelectOption key={i} text={AlignmentsTranslationKey[position] as Locale} value={position} />)}

            </SettingsSelect>



            {/* <SettingsSelect
                text="[REACT_LABEL_BACKGROUND]"
                value={bgValue ? "show" : "hide"}
                onSelect={(labelBackground) =>
                {
                    const value = labelBackground === "show";
                    saveSystemDetailsDefaultStyle(systemId, { labelBackground: value });
                }}
            >
                {labelBackground.map((background, i) => <SettingsSelectOption key={i} text={background} value={background} />)}

            </SettingsSelect> */}

            <SettingsSelect
                text="[REACT_FONT_WEIGHT]"
                value={defaultPlanStyle?.fontWeight}
                onSelect={(fontWeight) =>
                {
                    saveSystemDetailsDefaultStyle(systemId, { fontWeight });
                }}
            >
                {fontWeights.map((weight, i) => <SettingsSelectOption key={i} text={weight as Locale} value={weight} />)}

            </SettingsSelect>
            <SettingsSelect
                text="[REACT_FONT_FAMILY]"
                value={defaultPlanStyle?.fontFamily}
                onSelect={(fontFamily) =>
                {
                    saveSystemDetailsDefaultStyle(systemId, { fontFamily });
                }}
            >
                {fontFamilies.map((family, i) => <SettingsSelectOption key={i} text={family.label as Locale} value={family.label} />)}
            </SettingsSelect>

            <SettingsNumberInput
                //lines="none"
                inputRef={fontSizeRef}
                text={`${t("TPL_BEEZ3_FONTSIZE")} (pt)` as Locale}
                value={defaultPlanStyle?.fontSize || 1}
                min={1}
                onChange={(fontSize) =>
                {
                    if (fontSize !== 0) {
                        saveSystemDetailsDefaultStyle(systemId, { fontSize });
                    } else {
                        if (fontSizeRef.current) {
                            fontSizeRef.current.value = defaultPlanStyle?.fontSize;
                        }
                    }
                }}
            />
            <SettingsNumberInput
                //lines="none"
                inputRef={IconScaleRef}
                text={`[REACT_ICON_SCALE], [REACT_FACTOR]` as Locale}
                min={1}
                step="0.01"
                value={defaultPlanStyle?.iconScale || 1}
                onChange={(iconScale) =>
                {
                    if (iconScale !== 0) {
                        saveSystemDetailsDefaultStyle(systemId, { iconScale });
                    } else {
                        if (IconScaleRef.current) {
                            IconScaleRef.current.value = defaultPlanStyle?.iconScale;
                        }
                    }
                }}
            />

            {/* <SettingsSelect
                text="[REACT_ICON_SCALE]"
                value={defaultPlanStyle?.iconScale || '1'}
                onSelect={(iconScale) =>
                {
                    saveSystemDetailsDefaultStyle(systemId, { iconScale });
                }}
            >
                <SettingsSelectOption text={'ICON_SIZE_QUARTER'} value='-4' />
                <SettingsSelectOption text={'ICON_SIZE_HALF'} value='-2' />
                <SettingsSelectOption text={'ICON_SIZE_FULL'} value='1' />
                <SettingsSelectOption text={'ICON_SIZE_DOUBLE'} value='2' />
            </SettingsSelect> */}


            <IonItem>
                <div style={{ width: "100%" }}>
                    <IonButton
                        color={"success"}
                        expand={"full"}
                        disabled={!systemId}
                        onClick={() =>
                        {
                            updatePlanStyle();
                        }}>{t("[REACT_APPLY_STYLE_TO_ALL_PLANS]")}</IonButton>
                </div>
            </IonItem>

        </SettingsCol>

        <SettingsCol></SettingsCol>
        <SettingsCol></SettingsCol>
    </>;
};

export default PlanView;
